/**
 * Vocabulário padronizado da Central de Ajuda — linguagem para usuários finais.
 * Mantém nomes de menu iguais à interface, com explicação em português quando couber.
 */

/** Rótulos canônicos (primeira menção pode incluir explicação entre parênteses). */
export const HELP_TERMS = {
  dashboard: "Dashboard",
  dashboardExplain: "Dashboard (painel de números e gráficos)",
  pipeline: "Pipeline de Vendas",
  pipelineExplain: "Pipeline de Vendas (funil de oportunidades)",
  composer: "área de mensagem",
  responsibleSelector: 'seletor "Responsável"',
  messageTemplate: "modelo de mensagem aprovado",
  whatsappOfficial: "WhatsApp oficial (Meta)",
  whatsappQr: "WhatsApp por QR Code",
  agentSkill: "função do agente",
  ura: "atendimento automático (chatbot ou telefone)",
  workspace: "conta da empresa",
  upgrade: "ampliar ou mudar de plano",
  masterAdmin: "administrador principal da plataforma",
  tooltip: "dica ao passar o mouse",
  chatbot: "chatbot",
  aiAgent: "agente de IA",
};

/**
 * Substituições para humanizar textos técnicos (inventário CSV, descrições geradas).
 * Ordem importa: padrões mais específicos primeiro.
 */
export const HELP_GLOSSARY_REPLACEMENTS = [
  [/WhatsApp Cloud API/gi, HELP_TERMS.whatsappOfficial],
  [/Meta Cloud API/gi, "Meta oficial"],
  [/Cloud API/gi, "conexão oficial (Meta)"],
  [/chip Responsável/gi, HELP_TERMS.responsibleSelector],
  [/\bchip\b/gi, "seletor"],
  [/\bcomposer\b/gi, HELP_TERMS.composer],
  [/\btooltip(s)?\b/gi, HELP_TERMS.tooltip],
  [/\bskill(s)?\b/gi, "função do agente$1"],
  [/\bfunção do agentes\b/gi, "funções do agente"],
  [/\bupgrade(s)?\b/gi, HELP_TERMS.upgrade],
  [/\bmaster\b/gi, HELP_TERMS.masterAdmin],
  [/\bworkspace(s)?\b/gi, "conta da empresa$1"],
  [/\btemplate(s)? de reengajamento\b/gi, "modelo de mensagem de reengajamento"],
  [/\btemplate(s)?\b/gi, "modelo de mensagem$1"],
  [/\bChatBot(s)?\b/g, "chatbot$1"],
  [/\bChatbot\b/g, "chatbot"],
  [/\bURA\b/g, HELP_TERMS.ura],
  [/\boutbound\b/gi, "primeiro contato iniciado pela empresa"],
  [/\bSIP\b/g, "ligações de voz"],
  [/\bgrant(s)? explícito(s)?\b/gi, "permissão concedida"],
  [/\bperfis plataforma\b/gi, "equipe interna da Xpro"],
  [/\bLogs de API\b/gi, "registros técnicos do sistema"],
  [/\bwebhook(s)?\b/gi, "integração automática$1"],
  [/\bOAuth\b/gi, "login autorizado"],
  [/\bwidget\b/gi, "chat no site"],
  [/\bgateway\b/gi, "ponte de integração"],
  [/\bDefault\b/g, "Canal genérico"],
  [/\bid_usuario\b/gi, "usuário"],
  [/\bid_agente\b/gi, "agente de IA"],
  [/\bURA=1\b/gi, "atendimento automático ativo"],
  [/\bbefore-change guard\b/gi, "validação antes de alterar"],
  [/\bplatform-knowledge\b/gi, "base de conhecimento da plataforma"],
  [/\bhelp-center-index\b/gi, "índice da Central de Ajuda"],
  [/\bhandoff\b/gi, "transferência"],
  [/\bKPIs\b/g, "indicadores"],
  [/\bGMV\b/g, "valor total vendido"],
  [/\bCRUD\b/gi, "cadastrar, editar e remover"],
  [/\bstub\b/gi, "em preparação"],
  [/\bsoftphone\b/gi, "telefone no navegador"],
  [/\bDataGrid\b/gi, "tabela"],
  [/\bACK\b/g, "confirmação de leitura"],
  [/\blocalStorage\b/gi, "memória do navegador"],
  [/\bdrag-and-drop\b/gi, "arrastar e soltar"],
  [/\bRAG\b/g, "busca em documentos cadastrados"],
  [/\bKanban\b/g, "quadro de tarefas"],
];

export function applyHelpGlossary(text) {
  let out = String(text || "").trim();
  if (!out) return "";
  HELP_GLOSSARY_REPLACEMENTS.forEach(([re, rep]) => {
    out = out.replace(re, rep);
  });
  return out.replace(/\s{2,}/g, " ").replace(/\s+([,.;])/g, "$1").trim();
}
